import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import * as actions from '../actions'
import { SubmissionError } from 'redux-form'
import SubmitValidationForm from '../components/profile/SubmitValidationForm'
import LoadingView from '../components/componentKit/LoadingView'
import MobileLeftMenu from '../components/componentKit2/MobileLeftMenu'
import cookie from 'react-cookie'
import Modal from 'boron/FadeModal'
import moment from 'moment'
import { api, domen } from '../config.js'
import CSSModules from 'react-css-modules'
import styles from './profileCreate.css'
import HeaderTask from '../components/componentKit2/HeaderTask'
import Menu from '../components/todayTask/Menu'
import { changeChatType, clearRenderChat, setAuth, setTypeId, PRIVATE_CHAT_ID } from '../actions'
import { Link } from 'react-router'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}
/**
 *  Компонент ProfileCreate.
 *  Используется для отображения страницы 'Профиль' (/profile)
 *
 */
class ProfileCreate extends Component {
  /**
   * @memberof ProfileCreate
   * @prop {object} propTypes - the props that are passed to this component
   * @prop {string} propTypes.token Токен
   * @prop {object} propTypes.userInfo Данные о юзере
   * @prop {object} propTypes.profileFields Заполненные данные профиля
   * @prop {object} propTypes.profileData Данные профиля
   * @prop {array} propTypes.bodyParams Данные параметров тела
   * @prop {object} propTypes.insurance Данные по страховке
   * @prop {string} propTypes.selectedProfile Выбранные профиль
   * @prop {boolean} propTypes.isFetching Индикатор загрузки
   *
   * */

  static propTypes = {
    token: PropTypes.string,
    userInfo: PropTypes.object.isRequired,
    profileFields: PropTypes.object.isRequired,
    profileData: PropTypes.object.isRequired,
    bodyParams: PropTypes.array,
    insurance: PropTypes.object,
    selectedProfile: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  componentWillMount() {
    if (window.mobilecheck()) {
      contentStyle.margin = '80px'
      contentStyle.width = '340px'
    }
  }

  componentDidUpdate() {
    const { profileData, dispatch, location } = this.props
    if (profileData && profileData.isFirstEdit) {
      dispatch({ type: 'IS_READY_TO_TASKS', isReadyToTasks: true })
    }
   /* console.log('didMount3')
    console.log(this.props)
    if(location.query.code){

      const data = {
        client_id: '902885252188-5e5idu7tcva354cu3tnn30pdvq12gvn7.apps.googleusercontent.com',
        client_secret: 'CzqVfEe9pZl63ZkVeFd0o52e',
        redirect_uri: 'http://localhost:3000/profile',
        grant_type: 'authorization_code',
        code:location.query.code
    }
    console.log(data)
      return fetch(`https://accounts.google.com/o/oauth2/token`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(json => {


        })
    }*/
  }

  componentDidMount() {
    const { dispatch, selectedProfile, fetchTaskDayIfNeeded, selectedTaskDay, location} = this.props
    dispatch(actions.fetchProfileIfNeeded(selectedProfile))
    dispatch(actions.fetchTaskDayIfNeeded(selectedTaskDay))
    dispatch({type: 'SET_MENU_LIST', index: 21})

		const url = location.pathname.slice(1);
		this.sengLogPageView(url)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedProfile !== this.props.selectedProfile) {
      const { dispatch, selectedProfile } = nextProps
      dispatch(actions.fetchProfileIfNeeded(selectedProfile))
    }

    if (nextProps.selectedTaskDay !== this.props.selectedTaskDay) {
      const { fetchTaskDayIfNeeded, selectedTaskDay, fetchChat } = nextProps
      this.props.dispatch(actions.fetchTaskDayIfNeeded(selectedTaskDay))
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props
    dispatch(actions.receiveProfile('reactjs', { data: [{ insurance: {}, bodyMeasures: [] }] }))
  }

	sengLogPageView(url, params) {
		const payload = {
			authToken: cookie.load('token'),
			data: {
				url,
				parameters: params ? params : null
			}
		};
		return fetch(`${api}/data/log-pageView`, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: JSON.stringify(payload)
		})
			.then(response => {
				return response.json()
			})
			.catch(console.error)
	}

  render() {

    const { profileData, insurance, selectedProfile, bodyParams, token, isFetching, showMobileLeftMenu, hideLeftMenu, showLeftMenu,
       isReadyToTasks, isBabyFeeding, dispatch, setAuth, profileFields, userInfo, taskDayData } = this.props
    const isEmpty = !profileData || !profileData.email
    const insuranceIsEmpty = !insurance
    const { firstName, lastName, program, photo, gender } = userInfo.data
    const { isLoad } = taskDayData
    const isAlfa = domen.isAlfa
    const isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let calendar, id
      if(taskDayData.dayData){
        calendar= taskDayData.dayData.calendar
        id= taskDayData.dayData.id
    }

    if(isAlfa){
        document.body.style.backgroundColor = "#f9f0f0"
    }
    if(isUnipro){
      document.body.style.backgroundColor = "#dbe9f2"
    }

    return (
      <div className={isAlfa ? styles.layoutAlfa : styles.layout}>
        {isEmpty
          ? (isFetching
            ? <LoadingView isUnipro={isUnipro} isTele2Lk={isTele2Lk} isAlfa={isAlfa} title="Загружается..."/>
            : <LoadingView isUnipro={isUnipro} isTele2Lk={isTele2Lk} isAlfa={isAlfa} title="Если вы видите это окно, значит мы делаем личный кабинет для вас удобнее! Напишите нам в чат тех поддержки (внизу справа)"/>)
          : <div  style={{ opacity: isFetching ? 0.5 : 1}}>

            { showMobileLeftMenu &&
            <MobileLeftMenu dayId={id} hideMenu={hideLeftMenu}/>
            }

          <HeaderTask
            program={program}
            showLeftMenu={showLeftMenu}
            fullName={firstName && lastName ? `${firstName} ${lastName}` : null}
            avatar={photo}
            setAuth={setAuth}
          />

          {showMobileLeftMenu &&
          <MobileLeftMenu dayId={id} hideMenu={hideLeftMenu} />
          }
            <div className={isAlfa ? styles.layoutInnerAlfa : styles.layoutInner}>
              <div className={styles.grid}>
                <div className={profileData.isFirstEdit ? styles.gridCellLayoutMenu14 : styles.gridCellLayoutMenu14Show}>
                  <div id="menu" className={profileData.isFirstEdit ? styles.gridLayoutMenuInner :styles.gridLayoutMenuInnerShow}>

                    <Menu fullName={`${firstName} ${lastName}`} dayId={id} gender={gender} />

                    {/*{ isLoad ? <CalendarList
                                calendar={calendar}
                                none={true}
                                dayId={id} role={role}
                                privateChatId={PRIVATE_CHAT_ID}
                                setTypeId ={setTypeId}
                                changeChatType={changeChatType}
                                clearRenderChat={clearRenderChat}
                    /> : null }*/}



                  </div>
                </div>{/*gridCellLayoutMenu14*/}

                <div className={styles.gridCellLayoutContentPocket34}>

                    <SubmitValidationForm
                      bodyMeasure={bodyParams}
                      profileData={profileData}
                      isReadyToTasks={isReadyToTasks}
                      feedDate={moment(profileData.lastBabyFeedMonth).format('YYYY-MM-DD')}
                      injuriesEx={profileData.injuriesExist}
                      isBabyFeed={profileData.isBabyFeeding}
                      prevSeasons={profileData.prevSeasons}
                      initialValues={{
              ...profileData,
              country: profileData.country,
              city:  profileData.city,
              birthday:profileData.birthday,
              workPosition: profileData.customUserFields.workPosition,
              workCard: profileData.customUserFields.workCard,
              //workTeam: profileData.customUserFields.workTeam,
              relativeWorkerName: profileData.customUserFields.relativeWorkerName,
              timezone: profileData.timezone,
              fullName: !insuranceIsEmpty && insurance.fullName
                ? insurance.fullName : '',
              profession: !insuranceIsEmpty && insurance.profession
                ? insurance.profession : '',
              passport: !insuranceIsEmpty && insurance.passport
                ? insurance.passport : '',
              address: !insuranceIsEmpty && insurance.address
                ? insurance.address : '',
              insuranceFile: !insuranceIsEmpty && insurance.insuranceFile
                ? insurance.insuranceFile : []
            }}
                onSubmit={ data => {
                if (profileData.program % 4 === 2) {
                  data.isBabyFeeding = isBabyFeeding
                }

                this.refs.loadingModal.show()
                data.didSports = profileFields.didSports
                data.babyCount = profileFields.babyCount

                data.injuryItems = profileFields.injuryItems
                data.diseases = profileFields.diseases
                data.injuriesExist = profileFields.injuriesExist
                data.timezone = data.timezone.value
                data.customUserFields = {
                    workPosition: data.workPosition,
                    relativeWorkerName: data.relativeWorkerName,
                    workRelation: profileData.customUserFields.workRelation,
									  workCard: profileData.customUserFields.workCard,
									  workCode: profileData.customUserFields.workCode,
                    workTeam: data.workTeam || (data.workTeamSelect ? data.workTeamSelect.value : null)
                }
                delete data.password;
                delete data.prevSeasons;
                delete data.bodyMeasures;
                delete data.photo;

                const payload = {
                  authToken: token ? token : cookie.load('token'),
                  data
                }

                return fetch(`${api}/user/user-update`, {
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  method: 'POST',
                  body: JSON.stringify(payload)
                })
                .then(response => response.json())
                .then(user => {
                  this.refs.loadingModal.hide()

                  if (!user.data) {
                    if(user.errorCode === 131){
                      this.refs.errorModal.show()
                    } else {
                      throw new SubmissionError({ _error: 'Что-то пошло не так, попробуйте снова.' })
                    }

                  } else {
                    this.refs.successModal.show()
                     dispatch(actions.fetchProfileIfNeeded(selectedProfile))
                  }
                })
            }}
              />

                </div>{/*gridCellLayoutContentPocket34*/}

              </div>{/*grid*/}
            </div>{/*layoutInner*/}

            <Modal ref='successModal' contentStyle={contentStyle}>
              <h2>Профиль обновлен!</h2>
              <br/>
              <h4>Мы проверим анкету на наличие опечаток и пришлём подтверждение по почте. Ознакомьтесь с разделом Вопросы/Ответы!</h4>
              <br/>
              <div className={styles.btnPrimary} onClick={() => {
                browserHistory.push('/task')
              }}>
                К заданиям
              </div>
              <div className="divider" />
              <div className={styles.btnAction} onClick={() => {
                this.refs.successModal.hide()
                dispatch({ type: 'IS_READY_TO_TASKS', isReadyToTasks: true })
              }}>
                Продолжить
              </div>
            </Modal>

            <Modal ref='failBirthdayModal' contentStyle={contentStyle}>
              <h2>Дата вашего рождения не верна, проверьте формат даты</h2>
              <br/>
              <div className={styles.btnAction} onClick={() => {
                this.refs.failBirthdayModal.hide()
              }}>
                Продолжить
              </div>
            </Modal>

            <Modal ref='failDatesModal' contentStyle={contentStyle}>
              <h2>Рождения вашего ребенка или число последнего месяца кормления грудью не верны</h2>
              <br/>
              <div className={styles.btnAction} onClick={() => {
                this.refs.failDatesModal.hide()
              }}>
                Продолжить
              </div>
            </Modal>
            <Modal ref='errorModal' contentStyle={contentStyle}>
              <h2>К этой группе уже присоединилось максимальное количество участников</h2>
              <br/>
              <div className={styles.btnAction} onClick={() => {
                this.refs.errorModal.hide()
              }}>
                Продолжить
              </div>
            </Modal>

            <Modal ref='loadingModal' contentStyle={contentStyle} backdrop={false}>
              <div className={styles.entryHeader}>
                <h2 className={styles.entryTitleCenter}>Загружается...</h2>
              </div>
              <div className={styles.textCenter}>
                <div className={styles.loaderMain}></div>
              </div>
            </Modal>

            {isReadyToTasks &&
              <ul className={styles.menuMobBottom}>
                  <li className={styles.menuMobBottomItem}>
                      <Link to={'/task'}  className={styles.menuMobBottomItemInner}>
                          <span className={styles.menuMobBottomIco}>
                            <svg className={styles.svgIcoBookMobile}>
                              <use xlinkHref="#ico-m-tasks"></use>
                            </svg>
                          </span>
                          <span className={styles.menuMobBottomTitle}>Задания</span>
                      </Link>
                  </li>
                  <li className={styles.menuMobBottomItem}>
                      <Link to={'/food'}  className={styles.menuMobBottomItemInner}>
                          <span className={styles.menuMobBottomIco}>
                            <svg className={styles.svgIcoFoodMobile}>
                              <use xlinkHref="#ico-m-food"></use>
                            </svg>
                          </span>
                          <span className={styles.menuMobBottomTitle}>Питание</span>
                      </Link>

                  </li>
                 <li className={styles.menuMobBottomItem}>
                      <Link to={'/chats/' + id}  className={styles.menuMobBottomItemInner}>
                          <span className={styles.menuMobBottomIco}>
                            <svg className={styles.svgIcoPhoto}>
                              <use xlinkHref="#ico-chat"></use>
                            </svg>
                          </span>
                          <span className={styles.menuMobBottomTitle}>Чат</span>
                      </Link>
                  </li>
                  <li className={styles.menuMobBottomItem}>
                      <Link to={'/reports'}  className={styles.menuMobBottomItemInner}>
                          <span className={styles.menuMobBottomIco}>
                            <svg className={styles.svgIcoBookMobile}>
                              <use xlinkHref="#ico-m-book"></use>
                            </svg>
                          </span>
                          <span className={styles.menuMobBottomTitle}>Зачеты</span>
                      </Link>
                  </li>
              </ul>
            }
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {

  const { selectedProfile, recivedProfile, userToken, birthday, isBabyFeeding, showMobileLeftMenu,
    babyBirthday, menuList, sign, babyFeed, isReadyToTasks, profileFields, sportsPast, userInfo, taskDayData} = state

  const {
    isFetching,
    lastUpdated,
    profileData,
    insurance,
    bodyParams
  } = recivedProfile[selectedProfile] || {
    isFetching: true,
    profileData: {}
  }

  return {
    userInfo,
    showMobileLeftMenu,
    sign,
    menuList,
    isBabyFeeding,
    taskDayData,
    selectedProfile,
    isFetching,
    lastUpdated,
    profileFields,
    profileData,
    insurance,
    bodyParams,
    birthday,
    babyBirthday,
    babyFeed,
    isReadyToTasks,
    sportsPast,
    isBabyFeed: isBabyFeeding,
    token: userToken.token
  }
}
const mapDispatchToProps = dispatch => ({
  setTypeId: bindActionCreators(setTypeId , dispatch),
  changeChatType: bindActionCreators(changeChatType , dispatch),
  clearRenderChat: bindActionCreators(clearRenderChat , dispatch),
  setAuth: bindActionCreators(setAuth , dispatch),
  showLeftMenu: bindActionCreators(
    () => dispatch({type: 'SHOW_LEFT_MENU', show: true}),
    dispatch
  ),
  hideLeftMenu: bindActionCreators(
    () => dispatch({type: 'SHOW_LEFT_MENU', show: false}),
    dispatch
  ),
  dispatch
})
ProfileCreate = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileCreate)

export default CSSModules(ProfileCreate, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/containers/ProfileCreate.js